import FinhudasSvg from "@assets/icons/finhudas.svg"

export const Logo = () => {
  return <img
    src={FinhudasSvg}
    className="h-[2.5rem]" />
}

export default Logo